import React from 'react';
// import { hydrate, render } from 'react-dom'
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
// registerServiceWorker();
unregister();


// const rootElement = document.getElementById('root');
// if (rootElement.hasChildNodes()) {
//   console.log('App: Hydrate');
//   hydrate(<App />, rootElement);
// } else {
//   console.log('App: Render');
//   render(<App />, rootElement);
// }



// WEBPACK FOOTER //
// ./src/index.js